// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import OmnichannelPage from "../pages/Omnichannel/Omnichannel";
const __wvcRoutePaths = ["/OmnichannelPage", "/omnicanal"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["cart", "cartpage", "central3cxpage", "centrales-3cx", "centrales-grandstream", "checkout", "checkoutpage", "dinstarproductspage", "grandstreamcentralpage", "grandstreamproductspage", "homepage", "inicio", "ms-teams-integration", "msteamsintegrationpage", "nuestra-oficina", "omnicanal", "omnichannelpage", "post", "producto-yealink", "productos-dinstar", "productos-grandstream", "sbc-seguridad-de-voz", "sbcseguridaddevozpage", "search", "servicios-ia", "serviciosiapage", "shop", "shoppage", "transcripcion-y-analisis-de-chats-y-llamadas", "transcriptionandanalysisofchatsandcallspage", "ubicacionpage", "yealinkproductpage"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      <Route path={__wvcRoutePaths[0]} element={<OmnichannelPage />} />
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[1]} element={<OmnichannelPage />} />
      
      
      
      
      
      
      
      
      
      
      
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
